import { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { SpeedReport, UserReport } from "../../../Api/reportingApi";

export const UserReporting = () => {
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        console.log(startDate, endDate);

        UserReport().then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'user-report.csv'); 
            document.body.appendChild(link);
            link.click();
            link.remove();

            window.URL.revokeObjectURL(url);

            setLoading(false);
        }).catch((error) => {
            setError(error);
            console.error(error);
        });
    };

    return <>
        <h1>User Reporting</h1>
        <p>This report provides information on users.</p>
        <Form>
            <br />
            <Button
                variant="primary"
                type="submit"
                onClick={handleSubmit}
                disabled={loading}
            >
                {loading && (
                    <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                    ></span>
                )}
                {!loading && "Submit"}
            </Button>
        </Form>
    </>
}